import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { usePmsMaintenanceCounter, PmsMaintenanceCounter } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<PmsMaintenanceCounter>
    useData={usePmsMaintenanceCounter}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
